import * as S from './styles'

const CatalogBreadcrumb = ({ current, parent, parentLink }) => {
  return (
    <S.Breadcrumb>
      <S.BreadcrumbItem>
        <S.BreadcrumbHome to='/chatbot-catalog'>
          <S.BreadcrumbIcon type='home' />
        </S.BreadcrumbHome>
      </S.BreadcrumbItem>
      {parent && (
        <S.BreadcrumbItem>
          <S.BreadcrumbParent>
            {parent}
          </S.BreadcrumbParent>
        </S.BreadcrumbItem>
      )}
      {parentLink && (
        <S.BreadcrumbItem>
          <S.BreadcrumbParentLink to={parentLink.url}>
            {parentLink.label}
          </S.BreadcrumbParentLink>
        </S.BreadcrumbItem>
      )}
      {current && (
        <S.BreadcrumbItem>
          <S.BreadcrumbActive>
            {current}
          </S.BreadcrumbActive>
        </S.BreadcrumbItem>
      )}
    </S.Breadcrumb>
  )
}

export default CatalogBreadcrumb
